@if (supplierBaskets && supplierBaskets.length) {
    <div class="container-md">
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-stretch">
                <fieldset class="border rounded-3 p-3">
                    <legend class="text-primary float-none w-auto px-3">
                        <em class="fas fa-id-badge pe-2"></em>
                        {{ 'Rechnungsadresse' | translate }}
                    </legend>
                    <div class="row">
                        <div class="col-6">
                            @if (invoiceAddress) {
                                <div>
                                    <strong class="text-primary pe-1">
                                        {{ invoiceAddress?.contactInfo?.customerInfo?.firstName }}
                                    </strong>
                                    <strong class="text-primary">
                                        {{ invoiceAddress?.contactInfo?.customerInfo?.lastName }}
                                    </strong>
                                    <div>{{ invoiceAddress?.contactInfo?.companyInfo?.name }}</div>
                                    <div>{{ invoiceAddress?.contactInfo?.companyInfo?.name2 }}</div>
                                    <div>{{ invoiceAddress?.address?.street }}</div>
                                    <div>{{ invoiceAddress?.address?.zip }} {{ invoiceAddress?.address?.city }}</div>
                                    <div>{{ invoiceAddress?.address?.country | alpha2CountryCode | async }}</div>
                                </div>
                            }
                        </div>
                        @if (isEditableStep && isMoreThanOneInvoiceAddress) {
                            <div class="col-6 d-flex justify-content-end">
                                <em
                                    class="fas fa-edit fs-20 text-primary cursor-pointer"
                                    (click)="openInvoiceAddressDialog()"
                                ></em>
                            </div>
                        }
                    </div>
                </fieldset>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-stretch">
                <fieldset class="border rounded-3 p-3">
                    <legend class="text-primary float-none w-auto px-3">
                        <em class="fas fa-map-marked-alt pe-2"></em>
                        {{ 'Lieferadresse' | translate }}
                    </legend>
                    <div class="row">
                        <div class="col-6">
                            @if (deliveryAddress) {
                                <div>
                                    <strong class="text-primary pe-1">
                                        {{ deliveryAddress?.contactInfo?.customerInfo?.firstName }}
                                    </strong>
                                    <strong class="text-primary">
                                        {{ deliveryAddress?.contactInfo?.customerInfo?.lastName }}
                                    </strong>
                                    <div>{{ deliveryAddress?.contactInfo?.companyInfo?.name }}</div>
                                    <div>{{ deliveryAddress?.contactInfo?.companyInfo?.name2 }}</div>
                                    <div>{{ deliveryAddress?.address?.street }}</div>
                                    <div>{{ deliveryAddress?.address?.zip }} {{ deliveryAddress?.address?.city }}</div>
                                    <div>{{ deliveryAddress?.address?.country | alpha2CountryCode | async }}</div>
                                </div>
                            }
                        </div>
                        @if (isEditableStep) {
                            <div class="col-6 d-flex justify-content-end">
                                <em
                                    class="fas fa-edit fs-20 text-primary cursor-pointer"
                                    data-cy="BASKET_OPEN_DELIVERY_ADDRESS"
                                    (click)="openDeliveryAddressDialog()"
                                ></em>
                            </div>
                        }
                    </div>
                </fieldset>
            </div>
        </div>
        @if (!hasInvoiceAddress()) {
            <div class="row mt-3">
                <div class="col-12">
                    <div class="alert alert-warning mb-0">
                        {{
                            'Für den ausgewählten Buchungskreis ist keine Rechnungsadresse verfügbar. Bitte wählen Sie einen anderen Buchungskreis.'
                                | translate
                        }}
                    </div>
                </div>
            </div>
        }
        <div class="row">
            <div class="col-12">
                <fieldset class="border rounded-3 p-3">
                    <legend class="text-primary float-none w-auto px-3">
                        <em class="fas fa-id-badge pe-2"></em>
                        {{ 'Ansprechpartner und Bedingungen' | translate }}
                    </legend>
                    <div class="row">
                        <div class="col">
                            @for (supplierBasket of supplierBaskets; track supplierBasket.id; let isLast = $last) {
                                <ul>
                                    <basket-address-item
                                        [supplierBasket]="supplierBasket"
                                        [isLast]="isLast"
                                        [isEditableStep]="isEditableStep"
                                        (contactPersonsUpdated)="updateContactPersonsWithMapping($event)"
                                        (transmissionInfoUpdated)="updateTransmissionInfo($event)"
                                    ></basket-address-item>
                                </ul>
                            }
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        @if (isSupplierContactSelectionMissing()) {
            <section class="container-md mt-3">
                <div class="alert alert-warning">
                    {{ 'Ansprechpartner wählen' | translate }}
                </div>
            </section>
        }
        @if (showStepperButtons) {
            <div class="col">
                <div class="row justify-content-between basket-stepper-nav">
                    <div class="col-auto">
                        <button class="btn btn-outline-dark float-left" (click)="onClickPrevious()">
                            {{ 'Zurück' | translate }}
                        </button>
                    </div>
                    <div class="col-auto">
                        <button
                            class="btn btn-primary"
                            (click)="onClickNext()"
                            [disabled]="!canProceedToSummary()"
                        >
                            {{ 'Weiter' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        }
    </div>
}
